import React from "react";
import "../styles/Footer.css";

function Footer() {
  return (
    <footer className="footer">
      {/* Top part: menu + disclaimer, centered like sections */}
      <div className="footer-container">
        <div className="footer-menu">
          <h2>Menu</h2>
          <ul>
            <li><a href="#about">About Us</a></li>
            <li><a href="#foundation">Our Foundation</a></li>
            <li><a href="#who-we-are">Who We Are</a></li>
            <li><a href="#practices">Our Practices</a></li>
            <li><a href="#blog">Blog</a></li>
            <li><a href="#contact">Contact Us</a></li>
          </ul>
        </div>

        <div className="footer-disclaimer">
          <h2>Disclaimer</h2>
          <p>
            In accordance with the rules of the Bar Council of India, law firms are prohibited from soliciting work and advertising. By accessing this website (www.nyayom.com), you acknowledge and agree that there has been no advertisement, solicitation, invitation, or inducement from us or any of our members to solicit work through this website. The use of this site does not create a lawyer-client relationship and should not be construed as an invitation to form such a relationship or as legal advice.
          </p>
          <p>
            The information on this website is provided for general informational purposes only. We do not guarantee that the content is current, complete, or accurate. We are not responsible for any consequences resulting from actions taken by users based on the information provided on this website.
          </p>
        </div>
      </div>

      {/* Bottom bar: full width */}
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Nyayom Legal Services. All Rights Reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
